import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Davidlinthicumhero from "./sections/Davidlinthicumhero";
import Expertbiography from "./sections/Expertbiography";
import Impactmetrics from "./sections/Impactmetrics";
import Professionalfooter from "./sections/Professionalfooter";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Davidlinthicumhero />
      <main>
        <Expertbiography />
        <Impactmetrics />
        <Professionalfooter />
      </main>
      <Footer />
    </div>;
}